import React, { Fragment, useState, useEffect } from 'react';
import Form from './components/Form'
import Dating from './components/Dating'


function App() {

  // citas en local storage
  let initialDatings = JSON.parse(localStorage.getItem('datings'));
  if (!initialDatings) {
    initialDatings = [];
  }
  //Arreglo de citas
  const [datings, saveDating] = useState(initialDatings);

  // useEffect para realizar ciertas operaciones cuando el state cambia
  // siempre es un arrow function ,cuando el componente esta listo y cuando se actualiza algo
  useEffect((...initialDatings) => {
    // console.log('Documento listo o algo paso con las citas')
    if (initialDatings) {
      localStorage.setItem('datings', JSON.stringify(datings));
    } else {
      localStorage.setItem('datings', JSON.stringify([]));
    }
  }, [datings]);


  //funcion que tome las citas actuales y agruege la nueva
  const createDate = date => {
    // console.log(date);
    saveDating([
      ...datings,
      date
    ])
  }

  //funcion que elimina una cita con su id
  const deleteDating = (id) => {
    const new_datings = datings.filter((dating) => dating.id !== id);
    // console.log(id);    
    saveDating(new_datings);
  }

  console.log(datings.length);

  //mensaje condicional
  const conditional_title = datings.length === 0 ? 'No hay citas' : 'Administra tus citas';

  return (
    <Fragment>
      <h1>Administración de Pacientes</h1>
      <div className="container">
        <div className="row">
          <div className="one-half column">
            <Form
              createDate={createDate}
            />
          </div>
          <div className="one-half column">
            <h2>{conditional_title}</h2>
            {datings.map(current_date =>
              <Dating
                key={current_date.id}
                current_date={current_date}
                deleteDating={deleteDating}
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default App;
